import Category from '@/models/Category';
import { AxiosError } from 'axios';

export enum CategoryManagementTypes {
    CREATE_CATEGORY_REQUEST = '@categoryManagement/CREATE_CATEGORY_REQUEST',
    CREATE_CATEGORY_SUCCESS = '@categoryManagement/CREATE_CATEGORY_SUCCESS',
    CREATE_CATEGORY_FAILURE = '@categoryManagement/CREATE_CATEGORY_FAILURE',

    ACTIVATE_CATEGORY_RESQUEST = '@categoryManagement/ACTIVATE_CATEGORY_RESQUEST',
    ACTIVATE_CATEGORY_SUCCESS = '@categoryManagement/ACTIVATE_CATEGORY_SUCCESS',
    ACTIVATE_CATEGORY_FAILURE = '@categoryManagement/ACTIVATE_CATEGORY_FAILURE',

    INACTIVATE_CATEGORY_RESQUEST = '@categoryManagement/INACTIVATE_CATEGORY_RESQUEST',
    INACTIVATE_CATEGORY_SUCCESS = '@categoryManagement/INACTIVATE_CATEGORY_SUCCESS',
    INACTIVATE_CATEGORY_FAILURE = '@categoryManagement/INACTIVATE_CATEGORY_FAILURE',

    CATEGORY_MANAGEMENT_CLEAR = '@categoryManagement/CATEGORY_MANAGEMENT_CLEAR',
}

export interface CategoryManagementState {
    loading: boolean;
    hasError: boolean;
    error?: AxiosError<Category>;
    success: boolean;
}
